<template>
  <div class="container" v-loading="loading">

    <div class="main">

      <div class="title">
        <p @click="backToList">&lt;&nbsp;返回列表</p>
      </div>

      <div class="card" id="table_card">

        <div class="content_wrap">
          <div class="row1">
            <table class="info_tbl">
              <tr class="head">
                <td v-for="(item,index) of headList">
                  {{ item.label }}
                </td>
              </tr>

              <tr>
                <td>{{patient_info.Name}}</td>
                <td  >{{patient_info.Mobile}}</td>
                <td v-if="!flagTypeFollow">{{patient_info.AdmitNo}}</td>
                <td>{{patient_info.Age}}</td>
                <td>{{patient_info.Sex}}</td>
                <td  v-if="!flagTypeFollow">{{patient_info.Dept}}</td>
              </tr>
            </table>
          </div>

          <div class="row3">
            <span class="t2">日期范围：</span>
            <span class="st">
              <el-date-picker type="date" v-model="startDate" :clearable="clearDateEnable" :picker-options="startDatePickerOptions">
              </el-date-picker>
            </span>
            <div class="hour-select">
              <el-select v-model="startHour" @change="setEndHourSelectOptions()" :key="startHourSelectKey">
                <el-option v-for="item in startHourSelectOptions" :key="item.value" :value="item.value" :disabled="item.disable">
                </el-option>
              </el-select>
              时
            </div>
            <span>至</span>
            <span>
              <el-date-picker type="date" v-model="endDate" :clearable="clearDateEnable" :picker-options="endDatePickerOptions" @focus="change">
              </el-date-picker>
            </span>
            <div class="hour-select">
              <el-select v-model="endHour" :key="endHourSelectKey" @change="setStartHourSelectOptions()">
                <el-option v-for="item in endHourSelectOptions" :key="item.value" :value="item.value" :disabled="item.disable">
                </el-option>
              </el-select>
              时
            </div>
            
          </div>
          <div class="range">
            <span>血糖低限：</span>
            <el-input @input="debounce(checkInputValue,1000, [low_glucose,'low_glucose'])" @blur="checkInputValue(low_glucose,'low_glucose', true)" type="number" min="3.1" max="13.8" step="0.1" v-model="low_glucose" size="small"></el-input>
            <span>mmol/L</span>
            <span style="margin-left:10px;">血糖高限：</span>
            <el-input @input="debounce(checkInputValue,1000, [high_glucose,'high_glucose'])" @blur="checkInputValue(high_glucose,'high_glucose', true)" type="number" min="3.1" max="13.8" step="0.1" v-model="high_glucose" size="small"></el-input>
            <span>mmol/L</span>
          </div>
          <div class="table-wrap">
            <div class="t2 news">
              <span>血糖监测记录</span> 
              <div>
                <el-checkbox v-model="radio1" >综合报告</el-checkbox>
                <el-checkbox v-model="radio2" >AGP图谱</el-checkbox>
                <el-checkbox v-model="radio3" >每日详情</el-checkbox>
                <el-button id="export_pdf" type="primary" @click="exportPDF" :disabled="exportBtnEnable" style="margin-left:20px;">导出报告</el-button>
              </div>
            </div>
            <div class="sep"></div>

            <div v-if="hasData">
              <div class="device_wrap">
                <div class="table-row table-head">
                  <span>序号</span>
                  <span>SN</span>
                  <span>开始时间</span>
                  <span>结束时间</span>
                </div>
                <div v-for="(item, index) in data_map" class="table-row" :key="item">
                  <div @click="changeStartDate(item[1], item[2], index)" :class="[index==selectIndex?'selecttableColoum':'tableColoum']">
                    <span>{{pageInfo.curIndex*perPage+index+1}}</span>
                    <span>{{item[0]}}</span>
                    <span>{{item[1]}}</span>
                    <span>{{item[2]}}</span>
                  </div>
                </div>
              </div>

              <div class="page_row">
                <el-button @click="prevPage()">上一页
                </el-button>
                <span>{{pageInfo.curIndex+1}}/{{pageInfo.pageNum}}</span>
                <el-button @click="nextPage()">下一页
                </el-button>
              </div>
            </div>

            <div v-if="noData">
              <div class="table-row table-head">
                <span>无数据</span>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

    <ReportFooter />

  </div>
  <!--container结束-->
</template>

<script>
import auth from '../auth/auth'
import ReportFooter from './ReportFooter'

export default {
  components: { ReportFooter },
  data () {
    return {
      low_glucose: 3.9,
      tmpLow_glucose: 3.9,
      high_glucose: 10,
      tmpHigh_glucose: 10,
      endHourSelectKey: 'endHourSelectKey',
      startHourSelectKey: "startHourSelectKey",
      startHourSelectOptions: new Array(25).fill(1).map((_, index) => { return { value: index, disable: false } }),
      endHourSelectOptions: new Array(25).fill(1).map((_, index) => { return { value: index, disable: false } }),
      patient_info: {
        Name: '-'
      },
      minHourRange: 72,
      maxHourRange: 336,
      startHour: 0,
      endHour: 24,
      oneHour: 3600000,
      info: {},
      time_range: '-',
      date_list: [],
      statistics: [],
      report_date: '',
      sg_data: [],
      ts: [],
      radio1:true,
      radio2:true,
      radio3:true,
      isMg: false,
      startDate: null,
      endDate: null,
      startDateText: '',
      dayNum: 14,
      startDateSave: null,
      endDateSave: null,
      data_map: [],
      cureNo: '',
      uid: 0,
      starDateLim:0,
      hasData: true,
      noData: false,
      loading: false,
      exportBtnEnable: false,
      clearDateEnable: false,
      startDatePickerOptions: {
        disabledDate: (time) => {
          if(this.starDateLim==0){
            return time.getTime() + (this.minHourRange - this.endHour + this.startHour) * this.oneHour > new Date().getTime()
          }else{
            return (time.getTime()  >= new Date(this.starDateLim*1000).getTime())
          }
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          return (time.getTime() > new Date().getTime() || time.getTime() > this.startDate.getTime() + (this.maxHourRange - this.endHour + this.startHour) * this.oneHour) || (time.getTime() < this.startDate.getTime() + (this.minHourRange - this.endHour + this.startHour) * this.oneHour)
        }
      },
      total: [],
      pageInfo: {
        curIndex: 0,
        pageNum: 0
      },
      perPage: 6,
      selectIndex: null,
      timer: null,
      flagTypeFollow:false,
      headList:[
        {label:'姓名'},
        {label:'手机号'},
        {label:'住院号/门诊号'},
        {label:'年龄'},
        {label:'性别'},
        {label:'科室'},
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path
    })
  },
  mounted () {
    let app_type =sessionStorage.getItem('app_type')
      if(app_type=='EasyFollow'){
        this.flagTypeFollow =true
        this.headList =[
        {label:'姓名'},
        {label:'手机号'},
        {label:'出生日期'},
        {label:'性别'},
        ]
      }
    this.$nextTick(() => {
      if (!this.fromPath || !this.fromPath.match(/report/g)) {
        this.pageInfo.curIndex = 0
      }
    })
    this.low_glucose =sessionStorage.getItem('low_glucose')||3.9
    this.high_glucose=  sessionStorage.getItem('high_glucose')||10
    let req = this.getRequest()
    this.cureNo = req.cureNo;
    let patientInfo = sessionStorage.getItem('ReportPatientInfo');
    try {
      patientInfo = JSON.parse(patientInfo)
    } catch (e) {
      return;
    }
    this.patient_info.Name = patientInfo.name;
    this.patient_info.Mobile = patientInfo.mobile;
    this.patient_info.Age = patientInfo.age>0?patientInfo.age:'';
    this.patient_info.AdmitNo = patientInfo.cureNo;
    this.patient_info.Dept = patientInfo.dept;
    this.patient_info.Sex = patientInfo.sex;
    this.patient_info.Diag = patientInfo.follow_diagnosis;
    this.patient_info.bed =patientInfo.bed
    if(this.flagTypeFollow){
       this.patient_info.birthday =patientInfo.birthday?auth.formatterDate3(new Date(patientInfo.birthday).getTime()/1000):''
    }else{
       this.patient_info.birthday =patientInfo.birthday?auth.formatterDate3(patientInfo.birthday):''
    }
   
    this.uid = patientInfo.uid;
    this.pageInfo.curIndex = new Number(sessionStorage.getItem('pageIndex')).valueOf()
    setTimeout(() => {
      let curDate = new Date();
      
      this.$http.get('/api/v2.1/device/' + patientInfo.uid + '/records?flag=report').then(function (res) {
        let error = res.data.error;
        if (0 == error) {
          let data_map = [];
          let total = [];
          for (let i = res.data.data.tyDeviceRecord.length - 1; i >= 0; i--) {
            total.push(res.data.data.tyDeviceRecord[i])
          }
          if(res.data.data.tyDeviceRecord.length>0){
            this.starDateLim =res.data.data.tyDeviceRecord[res.data.data.tyDeviceRecord.length - 1][1]
          }
          if(this.starDateLim){
            curDate=new Date(this.starDateLim*1000)
            this.endDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
            this.startDate = new Date(this.endDate.getTime() - this.minHourRange * this.oneHour);
          }else{
            this.endDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());
            this.startDate = new Date(this.endDate.getTime() - this.minHourRange * this.oneHour);
          }
          this.total = total;
          this.pageInfo.pageNum = Math.ceil(this.total.length / this.perPage);
          this.updatePage(this.pageInfo.curIndex);
        }
      }, function (err) {
      })

      return;
    }, 0)
  },
  methods: {
    // 防抖函数
    debounce (func, delay, agm) {
      return (() => {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          func.apply(this, agm)
        }, delay)
      })()
    },
    checkInputValue (value, flag, isBlur = false) {
      // 判断是否为一位小数
      if (typeof value === 'number' || value.match(/^[\d]+(\.[\d])?$/g)) {
        let num = +value
        if (flag === "high_glucose") {
          if (num > 13.8 || num < 3.1) {
            this.$message.warning("输入的血糖值范围为3.1~13.8mol/L")
            if (isBlur) {
              this.high_glucose = this.tmpHigh_glucose
            }
          } else if (+this.high_glucose <= +this.low_glucose) {
            this.$message.warning("血糖低限应小于血糖高限")
            if (isBlur) {
              this.high_glucose = Math.round(this.low_glucose + 0.1)
            }
          } else {
            this.tmpHigh_glucose = value
          }
        } else {
          if (num > 13.8 || num < 3.1) {
            this.$message.warning("输入的血糖值范围为3.1~13.8mol/L")
            if (isBlur) {
              this.low_glucose = this.tmpLow_glucose
            }
          } else if (+this.high_glucose <= +this.low_glucose) {
            this.$message.warning("血糖低限应小于血糖高限")
            if (isBlur) {
              this.low_glucose = Math.round(this.high_glucose - 0.1)
            }
          } else {
            this.tmpLow_glucose = value
          }
        }
      } else {
        this.$message.warning("请输入数字，保留一位小数")
        if (flag === "high_glucose") {
          if (isBlur) {
            this.high_glucose = this.tmpHigh_glucose
          }
        } else {
          if (isBlur) {
            this.low_glucose = this.tmpLow_glucose
          }
        }
      }
    },
    setEndHourSelectOptions () {
      this.endHourSelectOptions = this.endHourSelectOptions.map(item => {
        return {
          value: item.value,
          disable: this.isEndHourDisable(item.value)
        }
      })
      this.endHourSelectKey += 1
    },
    setStartHourSelectOptions () {
      this.startHourSelectOptions = this.startHourSelectOptions.map(item => {
        return {
          value: item.value,
          disable: this.isStartHourDisable(item.value)
        }
      })
      this.startHourSelectKey += 1
    },
    isEndHourDisable (hour) {
      return this.endDate.getTime() - this.startDate.getTime() > (this.maxHourRange - hour + this.startHour) * this.oneHour || this.endDate.getTime() - this.startDate.getTime() < (this.minHourRange - hour + this.startHour) * this.oneHour
    },
    isStartHourDisable (hour) {
      return this.endDate.getTime() - this.startDate.getTime() > (this.maxHourRange - this.endHour + hour) * this.oneHour || this.endDate.getTime() - this.startDate.getTime() < (this.minHourRange - this.endHour + hour) * this.oneHour|| (this.startDate.getTime() +(hour) * this.oneHour >= new Date(this.starDateLim*1000).getTime())
    },
    updateHourSelectOptions () {
      this.setStartHourSelectOptions()
      this.setEndHourSelectOptions()
    },
    change () {
      let unable = document.getElementsByClassName('normal disabled');
      unable.onclick = () => {
        this.$message.error(`报告周期最多可选择${this.maxTimeRange}天`);
      }
    },
    changeStartDate (newStartDate, newEndDate, index) {
      this.selectIndex = index
      newStartDate = new Date(newStartDate)
      newEndDate = new Date(newEndDate)
      this.startDate = new Date(newStartDate.getFullYear(), newStartDate.getMonth(), newStartDate.getDate());
      this.startHour = newStartDate.getHours()
      let endDate = new Date(newEndDate.getFullYear(), newEndDate.getMonth(), newEndDate.getDate());
      let endHour = newEndDate.getHours() + 1
      const timeRange = newEndDate - newStartDate + (endHour - this.startHour) * this.oneHour
      const minRange = this.minHourRange * this.oneHour
      const maxRange = this.maxHourRange * this.oneHour
      if (timeRange < minRange) {
        if (this.startHour === 0) {
          this.endDate = new Date(this.startDate.getTime() + minRange - 24 * this.oneHour)
          this.endHour = 24
        } else {
          this.endDate = new Date(this.startDate.getTime() + minRange)
          this.endHour = this.startHour
        }
      } else if (timeRange > maxRange) {
        if (this.startHour === 0) {
          this.endDate = new Date(this.startDate.getTime() + maxRange - 24 * this.oneHour)
          this.endHour = 24
        } else {
          this.endDate = new Date(this.startDate.getTime() + maxRange)
          this.endHour = this.startHour
        }
      } else {
        this.endDate = endDate
        this.endHour = endHour
      }
      this.updateHourSelectOptions()
    },
    prevPage () {
      if (this.pageInfo.curIndex > 0) {
        this.updatePage(this.pageInfo.curIndex - 1);
      }
    },
    nextPage () {
      if (this.pageInfo.curIndex < (this.pageInfo.pageNum - 1)) {
        this.updatePage(this.pageInfo.curIndex + 1);
      }
    },

    updatePage (pageIndex) {
      let size = this.total.length;
      let curIndex = pageIndex;
      let perPage = this.perPage;
      this.pageInfo.curIndex = curIndex;
      sessionStorage.setItem('pageIndex', pageIndex)
      let data_map = [];
      for (let i = 0; i < perPage; i++) {
        let pos = curIndex * perPage + i;
        if (pos >= size) {
          break;
        }
        let item = this.total[pos];

        if (item[1] == 0) {
          item[1] = (new Date()).getTime() / 1000;
        }
        data_map.push([
          auth.deviceSNFormatV2(item[2], 'TRANS'),
          auth.formatterDate1a(new Date(item[0] * 1000)),
          auth.formatterDate1a(new Date(item[1] * 1000)),
        ])
      }
      this.data_map = data_map;

    },
    backToList () {
      this.$router.push('/reportList')
    },
    formatDate (d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    },
    exportPDF () {
      console.log(this.radio1)
      if(!this.radio1&&!this.radio2&&!this.radio3)return
      let params = {};
      params['cureNo'] = this.cureNo;
      params['uid'] = this.uid;
      params['radio1'] = this.radio1;
      params['radio2'] = this.radio2;
      params['radio3'] = this.radio3;
      params['endDate'] = this.formatDate(this.endDate);
      params['endDateTime'] = this.endDate.getTime() / 1000;
      params['dayNum'] = (this.endDate.setHours(0, 0, 0, 0) - this.startDate.setHours(0, 0, 0, 0)) / ((this.oneHour) * 24) + 1 || 1;
      params['dayNum'] = params['dayNum'] > 15 ? 15 : params['dayNum']
      sessionStorage.setItem('low_glucose', this.low_glucose)
      sessionStorage.setItem('high_glucose', this.high_glucose)
      sessionStorage.setItem('startHour', this.startHour)
      sessionStorage.setItem('endHour', this.endHour)
      if (this.patient_info) {
        params['patient_info'] = this.patient_info;
      }
      if (this.info) {
        params['info'] = this.info;
      }
      sessionStorage.setItem('hcgm_report_params', JSON.stringify(params))
      this.$router.push('/report1');
    },

    getRequest () {
      let href = location.href;
      let theRequest = {};
      if (href.indexOf("?") != -1) {
        let search = href.substring(href.indexOf("?") + 1)
        let strs = search.split("&");
        for (let i = 0; i < strs.length; i++) {
          let pair = strs[i].split("=");
          theRequest[pair[0]] = unescape(pair[1]);
        }

      }
      return theRequest;
    },

  },
  watch: {
    startDate (newvalue, oldvalue) {
      if (newvalue) {
        let addTime = this.endDate.getTime() - newvalue.getTime() + (this.endHour - this.startHour) * this.oneHour
        if (addTime > this.oneHour * this.maxHourRange) {
          this.endDate = new Date(newvalue.getTime() + this.oneHour * this.maxHourRange)
        } else if (addTime < this.oneHour * this.minHourRange) {
          this.endDate = new Date(newvalue.getTime() + this.oneHour * this.minHourRange)
        }
        this.updateHourSelectOptions()
      }
    },
    endDate(val){
      if(val){
        this.updateHourSelectOptions()
      }
    }
  },
  beforeDestroy(){
    sessionStorage.setItem('low_glucose', this.low_glucose)
      sessionStorage.setItem('high_glucose', this.high_glucose)
  }
}
</script>

<style scoped>
p,
body,
html {
  margin: 0;
}

.container {
  min-height: 800px;
  background-color: #f4f4f4;
}

.container .main {
  width: 1200px;
  margin: 0 auto;
}

.container .main .title {
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  font-size: 26px;
  padding-top: 30px;
  padding-left: 50px;
  cursor: pointer;
}

.container .main .card {
  margin-top: 15px;
  width: 100%;
  height: 700px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
  font-size: 20px;
}

#table_card .content_wrap {
  width: 90%;
  margin: 0 auto;
}

.row1 {
  padding-top: 30px;
}

.row2 {
  /*width: 90%;*/
  /*margin: 0 auto;*/
  margin-top: 40px;
}

#dayRange {
  height: 30px;
  width: 80px;
}

.row3 {
  margin-top: 20px;
}

.row3 .st {
  font-size: 16px;
}

.table-wrap {
  margin-top: 20px;
  /*width: 80%;*/
}

.table-wrap .device_wrap {
  height: 320px;
}

.table-wrap .t2 {
  font-weight: 500;
}

.table-wrap .sep {
  height: 20px;
  border-bottom: 2px solid #999;
}

.table-wrap table {
  width: 96%;
  margin: 0 auto;
  /*margin-top:50px;*/
}

.table-wrap .table-row span {
  display: inline-block;
  text-align: center;
}

.table-wrap .table-head {
  margin-bottom: 10px;
  margin-top: 20px;
  font-weight: 500;
  border-bottom: 2px solid #999;
}

.table-wrap .table-row {
  height: 35px;
  font-size: 18px;
}
.table-wrap .table-row span:nth-child(1) {
  width: 10%;
}
.table-wrap .table-row span:nth-child(2) {
  width: 20%;
}
.table-wrap .table-row span:nth-child(3) {
  width: 30%;
}
.table-wrap .table-row span:nth-child(4) {
  width: 30%;
}

.row2 .t2 {
  font-weight: 500;
}

.info_tbl {
  width: 100%;
  /*margin: 0 auto;*/
  /*font-size:18px;*/
}

.info_tbl tr td:nth-child(n + 2) {
  text-align: center;
}

.info_tbl .head {
  font-weight: 500;
  height: 40px;
}

hr {
  width: 96%;
  margin: 0 auto;
}

@media print {
}
.tableColoum {
  cursor: pointer;
  display: inline;
  text-align: center;
}
.tableColoum:hover {
  background-color: #ccc;
}
.selecttableColoum {
  cursor: pointer;
  display: inline;
  text-align: center;
  background-color: #ccc;
}
/deep/ td.next-month {
  color: #48576a;
}
/deep/ td.next-month:hover {
  background-color: #20a0ff !important;
  color: #fff;
}
.el-select {
  width: 40px;
}
>>> .hour-select .el-input__inner {
  border: none;
  height: 35px;
}
>>> .hour-select .el-input__icon {
  width: 13px;
}
>>> .hour-select .el-input__icon + .el-input__inner {
  padding-right: 0px;
}
.el-date-editor.el-input {
  width: 122px;
}
.hour-select {
  display: inline-block;
  border: 1px solid #d1dbe5;
  border-radius: 2px;
}
.range .el-input__inner {
  padding: 3px 0;
}
.range {
  margin-top: 10px;
}
.range .el-input--small {
  width: 70px;
}
.el-input--small .el-input__inner {
  text-align: center;
}
.news{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// HCGMReportPrepare.vue?c1640c54